import { user_addresses } from "@core/gql-mockups/addresses";

const { minimize_str } = require("@core/helpers/string");

export const GET_ADDRESSES = minimize_str(`
  query ($filter:AddressFilter,$sort: AddressSort) {
    result: getAllUserAddresses(filter:$filter,sort: $sort) ${user_addresses}
  }
`);

// all sites: Iran's states and cities from the storefront API's own queries (they replace the `iran_all_states` /
// `iran_all_cities` settings; same ids). 103 = Iran.
export const GET_IRAN_STATES_AND_CITIES = minimize_str(`
query {
  states: getAllStates(country_id: 103) {
    id
    name
    native
  }
  cities: getAllCities(country_id: 103) {
    id
    name
    native
    state_id
  }
}
`);
